<template>
    <div class="row">
        <div v-for="(animal, index) in species" :key="index" class="col-xxl-3 col-lg-4">
            <div class="card">
                <div class="card-header">
                    <div class="col-11">
                        <h5 class="card-title">{{ animal.species }}</h5>
                    </div>
                    <div class="col-1 text-end">
                        <button class="avatar-text avatar-md" @click="deleteSpecies(animal.id, index)"><i
                                class="feather feather-delete align-middle"></i></button>
                    </div>
                </div>
                <div v-for="(breed, bIndex) in animal.breeds" :key="bIndex" class="card-body custom-card-action">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="bg-warning text-white avatar-text">{{ breed.name.charAt(0) }}</div>
                        </div>
                        <div class="flex-grow-1">
                            <div>
                                <h5 class="fs-13 mb-1">{{
                                    breed.name }}</h5>
                            </div>
                        </div>
                        <div @click="deleteBreed(breed.id, bIndex, index)" class="flex-shrink-0 ms-2">
                            <button class="avatar-text avatar-md"><i
                                    class="feather feather-delete align-middle"></i></button>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-center">
                    <div class="input-group">
                        <input type="text" @keydown.enter="addBreed(animal.id, index)" class="form-control"
                            aria-label="Text input with segmented dropdown button"
                            :placeholder="animal.species + ' Cinsi Ekle'" :id="'species-' + animal.id">
                        <button @click="addBreed(animal.id, index)" type="button" class="btn btn-light-brand">
                            <i class="feather feather-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="theme-customizer">
        <div class="customizer-handle">
            <a href="javascript:void(0);" class="cutomizer-open-trigger bg-primary">
                <i class="feather-settings"></i>
            </a>
        </div>
        <div class="customizer-sidebar-wrapper">
            <div
                class="customizer-sidebar-header px-4 ht-80 border-bottom d-flex align-items-center justify-content-between">
                <h5 class="mb-0">Hayvan Türü Ekle</h5>
                <a href="javascript:void(0);" class="cutomizer-close-trigger d-flex">
                    <i class="feather-x"></i>
                </a>
            </div>
            <div class="customizer-sidebar-body position-relative p-4" data-scrollbar-target="#psScrollbarInit">
                <label for="species">Hayvan Türü</label>
                <input type="text" class="form-control" id="new-species-name">
            </div>
            <div class="customizer-sidebar-footer px-4 ht-60 border-top d-flex align-items-center gap-2">
                <div class="flex-fill w-50">
                    <a href="javascript:void(0);" class="cutomizer-close-trigger btn btn-light-brand">Vazgeç</a>
                </div>
                <div class="flex-fill w-50">
                    <button @click="addSpecies" type="button" class="btn btn-primary">Kaydet</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
export default {
    name: 'AnimalSpecies',
    async mounted() {
        try {
            const response = await this.$axios.get('breeds_by_species')
            this.species = response.data
        } catch (error) {
            console.error(error)
        }
        const script = document.createElement('script');
        script.src = 'assets/js/theme-customizer-init.min.js';
        script.onload = () => {
            console.log('vendors.js loaded dynamically');
        };
        document.head.appendChild(script);

    },
    data() {
        return {
            species: [],
        }
    },
    methods: {
        async deleteBreed(id, bIndex, sIndex) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    const response = await this.$axios.delete('animal_breed/' + id)
                    this.species[sIndex].breeds.splice(bIndex, 1)
                } catch (error) {
                    console.error(error)
                }
            }
        },

        async addBreed(id, sIndex) {
            const name = document.getElementById('species-' + id).value
            if (name == '') return
            try {
                const response = await this.$axios.post('animal_breed/', {
                    'name': name,
                    'species': id
                });
                this.species[sIndex].breeds.push(response.data)
                document.getElementById('species-' + id).value = ''
            } catch (error) {
                console.error(error)
            }
        },
        async deleteSpecies(id, sIndex) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    const response = await this.$axios.delete('animal_species/' + id)
                    this.species.splice(sIndex, 1)
                } catch (error) {
                    console.error(error)
                }
            }
        },
        async addSpecies() {
            const name = document.getElementById('new-species-name').value
            if (name == '') return
            try {
                const response = await this.$axios.post('animal_species/', {
                    'name': name
                });
                this.species.push({ "id": response.data.id, "species": response.data.name, "breeds": [] });
                document.getElementById('new-species-name').value = ''
            } catch (error) {
                console.error(error)
            }
        }
    },
    computed: {

    },
    watch: {

    },
}
</script>